import { el, setAttr } from 'redom';

class TextInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-textarea-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('textarea', {
      disabled: true
    });

    return this.input;

  }

  update(options) {

    setAttr(this.input, {
      placeholder: options.placeholder || ''
    });

  }

}

export default TextInputRenderer;